import { AppBar, Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";

// import { SplitButton } from "./SplitButton";

export interface IPayrollTimeSheetSetupToolbar {
	onSubmitButtonClickedHandler: (selectedItem: any) => void;
	onDeleteButtonClicked: () => void;
	payrollTimeSheetData: any;
	selectedPayPeriod: any;
}

export const PayrollTimeSheetSetupToolbar: FC<IPayrollTimeSheetSetupToolbar> = ({
	onSubmitButtonClickedHandler,
	onDeleteButtonClicked,
	payrollTimeSheetData,
	selectedPayPeriod
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				// // marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
				// position: "sticky",
				// bottom: 0,
				// top: 'auto',
				// bottom: 0,
				// backgroundColor: '#fff',
				// boxShadow: 'none',
				// alignItems: 'center',
				// zIndex: (theme) => theme.zIndex.drawer + 1, // ensure above other elements
			}}
		>
			<Toolbar>
				{/* <EnhancedButtonPrimeReact
					label="Save"
					// type="submit"
					onClickHandler={onSubmitButtonClickedHandler}
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/> */}
				{selectedPayPeriod && selectedPayPeriod.process ?
					<EnhancedButtonPrimeReact
						// icon="pi pi-trash"
						label="Save"
						raised
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						disabled={true}
					/>
					: <SplitButton
						options={["Save", "Save + Payroll"]}
						onClickHandler={onSubmitButtonClickedHandler}
						testId="t4-print-button"

					/>}
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					disabled={selectedPayPeriod && selectedPayPeriod.process ? true : false}
				/>
			</Toolbar>
		</AppBar>
	);
};
